<template>
    <div class="bgClass">
        <div class="loginClass">
            <div class="logo">還差一步，完成註冊</div>
            <div style="width: 100%;margin-top: 1%;"></div>
            <div class="content">感謝您加入NuMatch！<br> 我們已經發送了一份附有初始驗證信息的郵件至閣下的郵箱，<br> 閣下可前往郵箱內查看郵件內的<span>「初始驗證碼」</span>信息，<br> 並點擊郵件內的鏈接完成註冊。</div>
            <div style="width: 100%;margin-top: 1%;"></div>
        </div>
        <bottom></bottom>
    </div>
</template>

<script>
import { ElMessage } from "element-plus";
import {ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Bottom from "../components/bottom/bottom.vue";
import { registers } from "../api/index";
export default {
  name: 'App',
  components: {
      Bottom
  },
  setup() {
    const userRouter = useRouter();
    onMounted(() => {
    });

    const formRef = ref(null)
    const dynamicValidateForm = ref({
      name: '',
        email: '',
        show: '0'
    })
    const pushRegister = ()=>{
        userRouter.push({
          path: '/register',
          query: {},
        });
    }
    const pushlogin = ()=>{
        userRouter.push({
          path: '/login',
          query: {},
        });
    }

    const validateMail = (rule, value, callback)=>{
      if (value === '') {
        callback(new Error('請輸入電郵'))
      } else {
        // eslint-disable-next-line no-useless-escape
        if (/^[\w\.-]+@[a-z0-9\-]+(\.[a-z]{2,6}){1,3}$/i.test(value) === false) {
          callback(new Error('請輸入正確電郵'))
        }else {
          return true
          
        }
      }
    };

    const rules = {
      email: [
        {required: true, validator: validateMail, trigger: 'blur' }
      ],
      password: [{ required: true, message: "請輸入密碼", trigger: "blur" },
      { min: 8, max: 16, message: '密碼必須8-16個字', trigger: 'blur' }]
    };
    const submitForm = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          registers({
            "Accept-Language":"zh-HK",
            platform:"gateway",
            nickname: dynamicValidateForm.value.name,
            account: dynamicValidateForm.value.email,
          }).then((res) => {
            if (res.errCode === 200) {
              ElMessage.success("注册成功");
              userRouter.push({
                path: '/register',
                query: {},
              });
            } else {
              ElMessage.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    };
    
    return {
      submitForm,
      rules,
        pushlogin,
        userRouter,
        pushRegister,
        formRef,
        dynamicValidateForm
    };
  },
}
</script>

<style lang="less" scoped>
.bgClass{
    width: 100%;
    height: 100%;
    display: flex;
    
    flex-direction: column;
    justify-content: space-between;
}
.loginClass{
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.logo{
  font-size: 32px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 42px;
}
.content{
  font-size: 15px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  span{
      font-family: PingFangSC-Medium, PingFang SC;
      color: black;
  }
}

</style>